import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";
import * as URL from "../../helpers/url_helper";

const api = new APIClient();

export const fetchConversations = createAsyncThunk("inbox/list",
  async () => api.get(URL.GET_WA_CONVERSATIONS));

export const fetchConversationMessages = createAsyncThunk("inbox/messages",
  async (id) => {
    const data = await api.get(`${URL.GET_WA_CONVERSATION_MESSAGES}/${id}/messages`);
    return { id, messages: data };
  });

export const markConversationRead = createAsyncThunk("inbox/read",
  async (id) => {
    await api.create(`${URL.MARK_WA_CONVERSATION_READ}/${id}/read`, {});
    return id;
  });

export const replyToConversation = createAsyncThunk("inbox/reply",
  async ({ id, templateName, params }) =>
    api.create(`${URL.REPLY_WA_CONVERSATION}/${id}/reply`, { templateName, params }));

const slice = createSlice({
  name: "inbox",
  initialState: {
    conversations: [],
    unreadTotal: 0,
    loading: false,
    sending: false,
    error: null,
    activeId: null,
    messagesByConversation: {},
  },
  reducers: {
    setActiveConversation: (s, a) => { s.activeId = a.payload; },
  },
  extraReducers: (b) => {
    b.addCase(fetchConversations.pending,   (s) => { s.loading = true; s.error = null; });
    b.addCase(fetchConversations.fulfilled, (s, a) => {
      s.loading = false;
      s.conversations = a.payload?.conversations || [];
      s.unreadTotal = a.payload?.unreadTotal || 0;
    });
    b.addCase(fetchConversations.rejected,  (s, a) => { s.loading = false; s.error = a.error.message; });

    b.addCase(fetchConversationMessages.fulfilled, (s, a) => {
      s.messagesByConversation[a.payload.id] = a.payload.messages || [];
    });

    b.addCase(markConversationRead.fulfilled, (s, a) => {
      const conv = s.conversations.find(c => c.id === a.payload);
      if (conv) {
        s.unreadTotal = Math.max(0, s.unreadTotal - (conv.unreadCount || 0));
        conv.unreadCount = 0;
      }
    });

    b.addCase(replyToConversation.pending,   (s) => { s.sending = true; });
    b.addCase(replyToConversation.fulfilled, (s) => { s.sending = false; });
    b.addCase(replyToConversation.rejected,  (s, a) => { s.sending = false; s.error = a.error.message; });
  },
});

export const { setActiveConversation } = slice.actions;
export default slice.reducer;
